import { render, staticRenderFns } from "./ProjectContacts.vue?vue&type=template&id=01807436&lang=pug&"
import script from "./ProjectContacts.vue?vue&type=script&lang=js&"
export * from "./ProjectContacts.vue?vue&type=script&lang=js&"
import style0 from "./ProjectContacts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports